import { useState, useRef } from "react";
import Lightbox from "@/components/Lightbox";

const GALLERY_IMAGES = [
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_celebration-hub-359/artifacts/764i85mq_FOTO%201.png",
    alt: "Decoração batizado - tema branco clássico",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_celebration-hub-359/artifacts/lx8jiz0y_FOTO%202.png",
    alt: "Festa infantil Luca - tema música e leãozinho",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_celebration-hub-359/artifacts/fux47o8h_FOTO%203.png",
    alt: "Festa Aurora - tema sol dourado",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_celebration-hub-359/artifacts/2uv2rwup_FOTO%204.png",
    alt: "Festa Felipe - tema astronauta e espaço",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_celebration-hub-359/artifacts/vz336obi_FOTO%205.png",
    alt: "Festa Aurora - tema Arca de Noé",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_celebration-hub-359/artifacts/42pnw8kp_FOTO%206.png",
    alt: "Festa Ana Laura - tema moranguinho",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_celebration-hub-359/artifacts/4sw4usiy_FOTO%207.JPEG",
    alt: "Decoração Happy Birthday - laços vermelhos",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_celebration-hub-359/artifacts/azdi8u3c_FOTO%208.png",
    alt: "Chá de bebê Oh Baby - tema girafa safari",
  },
];

export default function Gallery() {
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const touchStart = useRef({ x: 0, y: 0 });

  const openLightbox = (i) => setLightboxIndex(i);
  const closeLightbox = () => setLightboxIndex(null);
  const prevImage = () => setLightboxIndex((p) => (p > 0 ? p - 1 : GALLERY_IMAGES.length - 1));
  const nextImage = () => setLightboxIndex((p) => (p < GALLERY_IMAGES.length - 1 ? p + 1 : 0));

  const handleTouchStart = (e) => {
    touchStart.current = { x: e.touches[0].clientX, y: e.touches[0].clientY };
  };

  const handleTouchEnd = (e, i) => {
    const dx = Math.abs(e.changedTouches[0].clientX - touchStart.current.x);
    const dy = Math.abs(e.changedTouches[0].clientY - touchStart.current.y);
    if (dx < 10 && dy < 10) {
      e.preventDefault();
      openLightbox(i);
    }
  };

  return (
    <section id="galeria" data-testid="gallery-section" className="py-24 bg-[#f9f9f9]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <span className="text-[#E4077B] text-xs tracking-[0.25em] uppercase font-medium">Portfólio</span>
          <h2
            className="text-3xl sm:text-4xl font-light text-[#1a1a1a] tracking-tight mt-3"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            Nossas Decorações
          </h2>
          <div className="w-12 h-0.5 bg-[#E4077B] mx-auto mt-4" />
        </div>

        {/* Masonry Grid */}
        <div
          className="gap-4 lg:gap-6"
          style={{
            columns: "1",
            columnGap: "1.5rem",
          }}
          data-testid="gallery-masonry"
        >
          <style>{`
            @media (min-width: 640px) {
              [data-testid="gallery-masonry"] { columns: 2 !important; }
            }
            @media (min-width: 1024px) {
              [data-testid="gallery-masonry"] { columns: 3 !important; }
            }
          `}</style>
          {GALLERY_IMAGES.map((img, i) => (
            <div
              key={i}
              className="mb-4 lg:mb-6 break-inside-avoid rounded-3xl cursor-pointer"
              data-testid={`gallery-image-${i}`}
              onClick={() => openLightbox(i)}
              onTouchStart={handleTouchStart}
              onTouchEnd={(e) => handleTouchEnd(e, i)}
              role="button"
              tabIndex={0}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-auto rounded-3xl"
                style={{ objectFit: "contain", display: "block" }}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>

      {lightboxIndex !== null && (
        <Lightbox
          images={GALLERY_IMAGES}
          currentIndex={lightboxIndex}
          onClose={closeLightbox}
          onPrev={prevImage}
          onNext={nextImage}
        />
      )}
    </section>
  );
}
